function strongPasswordStrengthBar () {
  return {
    restrict: 'E',
    scope: {
      passwordStrength: '<'
    },
    templateUrl: '/auth/directives/password-strength-bar/password-strength-bar-directive.html?$$REVISION$$'
  }
}

export { strongPasswordStrengthBar }
